import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=fdbed80c&"
import script from "./AboutModal.vue?vue&type=script&lang=js&"
export * from "./AboutModal.vue?vue&type=script&lang=js&"
import style0 from "./AboutModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AboutModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/AboutModal.vue
// module id = 2324
// module chunks = 1